import React, { useRef } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
  getSortedRowModel,
} from "@tanstack/react-table";
import { connect } from "react-redux";

import { EMPTY_STRING } from "../../../constants";
import { userActions } from "../../../redux/actions";
import { useResizableTableColumns } from "../../hooks/useResizableTableColumns";

const InfiniteScrollTable = ({
  columns,
  data,
  update,
  hasMore,
  isLoading,
  handleRowClick = false,
  endMessage = EMPTY_STRING,
  tableId,
  resizableColumns = true,
  user,
  store,
  updateUserInformation,
}) => {
  const scrollableTargetRef = useRef(
    `scrollableDiv${tableId ? `-${tableId}` : ""}`
  );
  const { formatColumns, getColumnWidthStyle, renderResizableHeader } =
    useResizableTableColumns({
      columns,
      tableId,
      resizableColumns,
      user,
      store,
      updateUserInformation,
      headerCellSelector: "th",
    });

  const table = useReactTable({
    data,
    columns: formatColumns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  const { getHeaderGroups, getRowModel } = table;
  const ScrollLoadingConponent = () => {
    return (
      <div className="w-100 py-2 d-flex justify-content-center align-items-center">
        Loading...
      </div>
    );
  };
  // Render the UI for your table

  return (
    <InfiniteScroll
      dataLength={data?.length}
      next={update}
      hasMore={hasMore}
      endMessage={endMessage}
      loader={isLoading ? <ScrollLoadingConponent /> : ""}
      scrollableTarget={scrollableTargetRef.current}
    >
      <div
        className="react-data-table-wrapper scrollableWrapper"
        id={scrollableTargetRef.current}
        style={{ overflowX: "auto" }}
      >
        <table
          className="react-data-table"
          style={{ minWidth: "100%", width: "max-content" }}
        >
          <thead>
            {getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => {
                  const columnKey =
                    header.column.columnDef.__columnKey || header.id;
                  return (
                    <th
                      key={header.id}
                      className="react-table-th-con"
                      style={getColumnWidthStyle(columnKey)}
                    >
                      {header.isPlaceholder ? null : (
                        <div
                          {...{
                            className: header.column.getCanSort() ? "" : "",
                            onClick: header.column.getToggleSortingHandler(),
                          }}
                          className="react-table-header-con"
                        >
                          {renderResizableHeader(
                            flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            ),
                            columnKey
                          )}
                        </div>
                      )}
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody className="react-data-table-body ">
            {getRowModel().rows.map((row) => (
              <tr
                key={row.id}
                className={`infinite-scroll-table-row ${
                  handleRowClick ? "cursor-pointer" : ""
                }`}
                onClick={() => {
                  if (handleRowClick) {
                    handleRowClick(row.original);
                  }
                }}
              >
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    className="react-table-td-con"
                    style={getColumnWidthStyle(
                      cell.column.columnDef.__columnKey || cell.column.id
                    )}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </InfiniteScroll>
  );
};

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  store: state.store,
});

const mapDispatchToProps = (dispatch) => ({
  updateUserInformation: (data, isSystemUser) =>
    dispatch(userActions.updateUserInformation(data, isSystemUser)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfiniteScrollTable);
